import { ResultPropsUebergeordneteBedarfe } from '../../../../../types/Survey/Analysis/FactorValues'
import Input from '../../../../UI/Input/Input'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import Number from '../../../../UI/Input/Number'
import { TrashIcon } from '@heroicons/react/24/outline'
import FloorAssignment from '../../../../UI/FloorManager/FloorAssignment'
import { FloorMappingEntryType } from '../../../../../types/Survey/Analysis/Concept'

const SingleUebergeordneterBedarf: React.FC<{
  data: ResultPropsUebergeordneteBedarfe
  onChange: (key: string) => (value: number) => void
  remove: () => void
}> = ({ data, onChange, remove }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  return (
    <div className="flex items-end gap-3" key={data.uuid}>
      <div className="w-1/4 shrink-0">
        <Input value={data.name} onChange={onChange('name')} />
      </div>
      <div className="w-1/4">
        <div className="text-sm">
          {!isNaN(data.originalPracticalQM) &&
            `${t.survey.analysis.calculation.values.originalValuePrefix}${data.originalPracticalQM}${t.generic.squareMeterSuffix}`}
        </div>
        <div className="text-sm">
          {data.isNormSelected
            ? t.survey.analysis.concept.optimization.uebergeordneteBedarfe.byNorm.yes
            : t.survey.analysis.concept.optimization.uebergeordneteBedarfe.byNorm.no}
        </div>
      </div>
      <div className="w-1/4">
        <Number decimal value={data.practicalQM} onChange={onChange('practicalQM')} suffix={t.generic.squareMeterSuffix} />
      </div>
      <div className="w-1/4 shrink-0">
        <FloorAssignment label targetUUID={data.uuid} type={FloorMappingEntryType.UEBERGEORDNETER_BEDARF} />
      </div>
      <div onClick={remove} className="w-6 aspect-square bg-red-500 rounded-full flex items-center justify-center text-white cursor-pointer">
        <TrashIcon className="stroke-blue hover:stroke-red w-5" />
      </div>
    </div>
  )
}

export default SingleUebergeordneterBedarf
